import React from "react"
import DOMPurify from "dompurify";
import dayjs from "dayjs";
import { convertToLocalTime } from "../../commonFunctions/commonFunctions";
import { CaseActions } from "../../Constantes/CaseActions";
import backmenuIcon from "../../images/back-menu.svg"
import arrowdownlargeIcon from "../../images/arrow-down-large.svg"
import arrowuplargeIcon from "../../images/arrow-up-large.svg"
import mailIcon from "../../images/mail.svg"
import mailforwardIcon from "../../images/mail-forward.svg"
import mailreplyIcon from "../../images/mail-reply.svg"
import { IconButton } from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { blockCase } from '../../redux/currentCase/thunks';
import { Chip } from '@material-ui/core';
import { Attachment } from '@material-ui/icons';
import { Box } from 'devextreme-react';

function Comment(props) {
  const {actionId, message, date, agent, state, showCommentInfo = true, titleFontSize, commentFontSize, parameters, files, downloadHistoryFile } = props;
  return (
    <div>
      {showCommentInfo && 
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: titleFontSize}} className="firmaHistorico"> 
        <div style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
          {actionId == CaseActions.EmailInbound && 
            <div style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
              <img height={20} src={mailreplyIcon} title="E-mail de entrada" />
              <IconButton id="reply-email" style={{padding: 4}} title="Responder e-mail" onClick={() => props.handleEmailReplyByCaseTrace(parameters)}><img height={20} src={backmenuIcon}/></IconButton>
            </div>
            }
          {actionId == CaseActions.EmailOutbound && <img height={20} src={mailforwardIcon} title="E-mail de saída" />}

          <span>{dayjs(convertToLocalTime(date)).format("DD/MM/YYYY HH:mm")}</span><span>-</span><span className="agent-name">{agent}</span><span>-</span><span>{state}</span>
        </div>
      </div>}
      {files != null && files.length > 0 && (
        <div className="firmaHistorico firmaHistoricoFiles">
          {/* <hr></hr> */}
          <div sx={{ display: 'flex', flexWrap: 'wrap', gap: ".4rem", padding: ".4rem", borderTop: '1px solid black' }}>
              {files.map((file) => (
                <Chip
                  key={file.caseTraceFileId}
                  label={file.fileName}
                  title={file.fileName}
                  size="small"
                  icon={<Attachment sx={{ fontSize: '0.75rem !important' }} />}
                  sx={{ borderRadius: '2px', bgcolor: '#275aa7', height: 22, fontSize: '0.7rem', fontWeight: 600 }}
                  onClick={(e) => downloadHistoryFile(file.blobGuid)}
                />
              ))}
            </div>
        </div>
      )}
      <div style={{fontSize: commentFontSize}} className="comment" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
    </div>
  );
}

export { Comment }